export enum RebalancingType {
  WALLET, // externally owned account
  VAULT, // smart contract vault (e.g. Enzyme Vault, SetToken)
}
